import { formatDateInt } from "@core/_utils/date.utils";
import { returnEmpty } from "@core/_utils/tools.utils";

export async function updateDelegate(result, self) {
    let wRes: any;
    let wMess: string;
    const wParams = formatRequest(result.entete);
    wRes = await self.requestTools.execUrlAction('setdelegate', wParams);
    self.checkTools.checkError(wRes);
    if (self.checkTools.getRes() === false) {
        wMess = returnEmpty(wRes.Message);
        if (wMess !== '') {
            self.checkTools.check.msg = wMess;
        }
        self._messageService.addErrorMsg(self.checkTools.getMsg(),self.translate.instant('Update_KO'));
        return;
    }
    
    wRes = await self.requestTools.execUrlAction('getdelegatelist', '');
    self.checkTools.checkError(wRes);
    if (self.checkTools.getRes() === false) {
        wMess = returnEmpty(wRes.Message);
        if (wMess !== '') {
            self.checkTools.check.msg = wMess;
        }
        self._messageService.addErrorMsg(self.checkTools.getMsg(), self.translate.instant('Get_Dlg_KO'));
        return;
    }
    return wRes;
}

export function formatRequest(adataentete) {
    const wdata = {
        Login: adataentete.fromLogin,
        UseDelegate: adataentete.useDelegate,
        DateBeginDelegate: formatDateInt(adataentete.dateBegin, false),
        DateEndDelegate:formatDateInt(adataentete.dateEnd, false),
        LoginDelegate: adataentete.delegatedLogin,
    };
    return wdata;
}